import React, { useState, useMemo, useEffect } from "react";
import {  useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";
import CommonService from "../../../services/Common/CommonService";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { DatePicker } from "@y0c/react-datepicker";

import {
  inventoryHistoryActions,
  masterActions,
  productActions,
} from "../../../_store";
import { useSelector, useDispatch } from "react-redux";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Select from "react-select";
import Toastr from "../../components/common/Toastr";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";

const InventoryHistory = () => {
  const dispatch = useDispatch();

  const currentUser = useSelector((x) => x.auth.user);
  const location = useLocation();
  const ProductID = location.state ? location.state.ProductID : 0;
  const ProductName = location.state ? location.state.ProductName : "";
  const Location = location.state ? location.state.Location : "";
  const WCProductID = location.state ? location.state.WCProductID : 0;
  const PDWCProductID = location.state ? location.state.PDWCProductID : 0;
  const IsGemar = location.state ? location.state.IsGemar : false;
  const IsPartyDeco = location.state ? location.state.IsPartyDeco : false;

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region Reducers ------------------  Reducers --------------------------------
  const inventoryHistoryList = useSelector(
    (x) => x.inventoryHistory.inventoryHistoryList
  );

  //#region Popup
  const transactionTypeDrpList = useSelector(
    (x) => x.master.transactionTypeDrpList
  );
  const vendorDrpList = useSelector((x) => x.master.vendorDrpList);
  const warehouseDrpList = useSelector((x) => x.master.warehouseDrpList);
  const stockQuantity = useSelector((x) => x.inventoryHistory.stockQuantity);
  const inventoryHistoryResponse = useSelector(
    (x) => x.inventoryHistory.inventoryHistoryResponse
  );
  const getInventoryDetails = useSelector((x) => x.product.productTabList);

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "TransactionTypeID") {
      newFormData.TransactionTypeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      newFormData.TransactionUnits = "";
      newFormData.FinalInventory = 0;
    } else if (title === "FromWareHouseID") {
      newFormData.FromWarehouseOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "ToWareHouseID") {
      newFormData.ToWarehouseOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "VendorID") {
      newFormData.VendorOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }

    setAddFormData(newFormData);
  };

  //Add contact function
  const handleChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    //const newFormData = { ...addFormData };
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "TransactionUnits") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      }else if(fieldName === 'LotNumber'){
        newFormData[fieldName] = fieldValue.trim()
      } 
      else {
        newFormData[fieldName] = fieldValue;
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    setAddFormData(newFormData);

    if (
      fieldName === "TransactionUnits"){
        const transactionUnits = Number(newFormData.TransactionUnits);
        if (transactionUnits === 0  && fieldValue !== "") {
         
          Toastr("Transaction Units cannot be zero", "warning");
          newFormData.TransactionUnits = ""; 
          newFormData.FinalInventory = 0; 
        } else if (
      fieldValue &&
      (newFormData.TransactionTypeOption.label === "Adjustment Credit" ||
        newFormData.TransactionTypeOption.label === "Purchase")
    ) {
      newFormData.FinalInventory =
        Number(getInventoryDetails.StockQuantity) +
        Number(newFormData.TransactionUnits);
    } else if (
      fieldName === "TransactionUnits" &&
      fieldValue &&
      newFormData.TransactionTypeOption.label === "Adjustment Debit"
    ) {
      if (getInventoryDetails.StockQuantity < newFormData.TransactionUnits) {
        newFormData.TransactionUnits = "";
        newFormData.FinalInventory = 0;
        Toastr(
          "Transaction Units cannot greater than Actual Inventory",
          "warning"
        );
      } else {
        newFormData.FinalInventory =
          Number(getInventoryDetails.StockQuantity) -
          Number(newFormData.TransactionUnits);
      }
    } else if (fieldName === "TransactionUnits" && !fieldValue) {
      newFormData.FinalInventory = 0;
    

    }

    setAddFormData(newFormData);
  }
  };

  const handleDateChange = (date) => {
    if(date)
    {
      newFormData.LotDate = date?.$d;
      setAddFormData(newFormData);
    }
   
  };

  //Add Submit data
  const handleAddFormSubmit = (event) => {
    showLoader();
    var error = false;

  if (newFormData.TransactionTypeID === 2) {
      if (
        !addFormData.TransactionTypeID ||
        addFormData.TransactionTypeID === 0 ||
        !addFormData.FromWareHouseID ||
        addFormData.FromWareHouseID === 0 ||
        !addFormData.ToWareHouseID ||
        addFormData.ToWareHouseID === 0 ||
        !addFormData.VendorID ||
        addFormData.VendorID === 0 ||
        !addFormData.InvoiceNumber || !addFormData.LotNumber || !addFormData.LotDate ||
        !addFormData.TransactionUnits || addFormData.TransactionUnits === 0
      ) {
        error = true;
      }
    } else if (
      newFormData.TransactionTypeID === 3 ||
      newFormData.TransactionTypeID === 4
    ) {
      if (
        !addFormData.TransactionTypeID ||
        addFormData.TransactionTypeID === 0 ||
        !addFormData.FromWareHouseID ||
        addFormData.FromWareHouseID === 0 ||
        !addFormData.InvoiceNumber ||
        !addFormData.TransactionUnits || addFormData.TransactionUnits === 0
      ) {
        error = true;
      }
    } else {
      if (
        !addFormData.TransactionTypeID ||
        addFormData.TransactionTypeID === 0 ||
        !addFormData.FromWareHouseID ||
        addFormData.FromWareHouseID === 0 ||
        !addFormData.VendorID ||
        addFormData.VendorID === 0 ||
        !addFormData.InvoiceNumber || !addFormData.LotNumber ||  !addFormData.LotDate ||
        !addFormData.TransactionUnits || addFormData.TransactionUnits === 0
      ) {
        error = true;
      }
    }

    if (!error) {
      setIsDisabled(true);

      if(addFormData?.TransactionTypeID===1)
      {
        let params = {
          LotNumber:  addFormData.LotNumber,
          ProductID:ProductID
        };
        CommonService.LotNumberExistCheck(params).then((res) => {
          if (res.data === 1) {
            saveInventoryManagement();
          }else
          {
          hideLoader();
          setIsDisabled(false);
          setSubmitted(true);
          Toastr("This Lot Number has already been created. Please enter another Lot Number.", "warning");
          }
        });
      }else
      {
        saveInventoryManagement();
      }

    } else {
      hideLoader();
      setSubmitted(true);
      Toastr("Please fill in the required missing fields", "warning");
    }
  };

  function saveInventoryManagement()
  {
    newFormData.ActualInventory =
    getInventoryDetails && getInventoryDetails.StockQuantity;
  const ApiData = {
    stock_quantity: newFormData.FinalInventory.toString(),
  };

  if (IsGemar === true && IsPartyDeco === true) {
    UpdateProductGemarAndPA(newFormData, ApiData);
  } else if (IsGemar === true) {
    UpdateProductGemar(newFormData, ApiData);
  } else if (IsPartyDeco === true) {
    UpdateProductPA(newFormData, ApiData);
  } else {
    hideLoader();
    setSubmitted(true);
    setIsDisabled(false); 
    Toastr("Data error", "warning");
  }
 }

  function UpdateProductGemar(newFormData, ApiData) {
    restApi
      .post("products/" + WCProductID, ApiData)
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          if (
            newFormData.TransactionTypeID === 3 ||
            newFormData.TransactionTypeID === 4
          )
            newFormData.VendorID = 0;
          dispatch(
            inventoryHistoryActions.insertTransactionHistory(newFormData)
          );
        } else {
          hideLoader();
          Toastr("Gemar : " + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();

        let msg = "";
        if (error.response) {
          if (error.response.data.code === "products_exists") {
            msg = "";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }

        Toastr("Gemar : " + msg, "warning");
        console.log();
      });
  }

  function UpdateProductPA(newFormData, ApiData) {
    restApi_PD
      .post("products/" + PDWCProductID, ApiData)
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          if (
            newFormData.TransactionTypeID === 3 ||
            newFormData.TransactionTypeID === 4
          )
            newFormData.VendorID = 0;
          dispatch(
            inventoryHistoryActions.insertTransactionHistory(newFormData)
          );
        } else {
          hideLoader();
          Toastr("PartyDeco : " + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();

        let msg = "";
        if (error.response) {
          if (error.response.data.code === "products_exists") {
            msg = "";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }

        Toastr("PartyDeco : " + msg, "warning");
        console.log();
      });
  }

  function UpdateProductGemarAndPA(newFormData, ApiData) {
    restApi
      .post("products/" + WCProductID, ApiData)
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          restApi_PD
            .post("products/" + PDWCProductID, ApiData)
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                if (
                  newFormData.TransactionTypeID === 3 ||
                  newFormData.TransactionTypeID === 4
                )
                  newFormData.VendorID = 0;
                dispatch(
                  inventoryHistoryActions.insertTransactionHistory(newFormData)
                );
              } else {
                hideLoader();
                Toastr("PartyDeco : " + PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();

              let msg = "";
              if (error.response) {
                if (error.response.data.code === "products_exists") {
                  msg = "";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "rest Api error";
              }

              Toastr("PartyDeco : " + msg, "warning");
            });
        } else {
          hideLoader();
          Toastr("Gemar : " + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();

        let msg = "";
        if (error.response) {
          if (error.response.data.code === "products_exists") {
            msg = "";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }

        Toastr("Gemar : " + msg, "warning");
        console.log();
      });
  }

  useEffect(() => {
    if (inventoryHistoryResponse === 1) {
      hideLoader();
      Toastr("Transaction history successfully added", "success");
      dispatch(
        inventoryHistoryActions.getInventoryHistoryListByID({ ProductID })
      );
      setLargeModal(false);
    }
  }, [inventoryHistoryResponse]);
  //#endregion

  const COLUMNS = [
    {
      Header: "Transaction Date",
      Footer: "Transaction Date",
      accessor: "CreatedDateString",
      justify: "center",
      fieldType: "Date",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },
    {
      Header: "Transaction Type",
      Footer: "Transaction Type",
      accessor: "TransactionType",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Warehouse",
      Footer: "Warehouse",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Invoice Number",
      Footer: "Invoice Number",
      accessor: "InvoiceNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Actual Inventory",
      Footer: "Actual Inventory",
      accessor: "ActualInventoryStr",
      fieldType: "commaSeparator",
      justify: "center",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },

    {
      Header: "Transaction Units",
      Footer: "Transaction Units",
      accessor: "TransactionUnitsStr",
      fieldType: "commaSeparator",
      justify: "center",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },

    {
      Header: "Final Inventory",
      Footer: "Final Inventory",
      accessor: "FinalInventoryStr",
      fieldType: "commaSeparator",
      justify: "center",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },
    
    {
      Header: "Created by",
      Footer: "Created by",
      accessor: "CreatedByName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Lot Number",
      Footer: "Lot Number",
      accessor: "LotNumber",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Lot Date",
      Footer: "Lot Date",
      accessor: "LotDateString",
      justify: "left",
      Filter: ColumnFilter,
    }
  ];

  const columns = useMemo(() => COLUMNS, []);
  const navigate = useNavigate();

  const [largeModal, setLargeModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isdisabled, setIsDisabled] = useState(false);

  //Add data
  const [addFormData, setAddFormData] = useState({
    ProductID: "",
    ProductName: "",
    TransactionTypeID: 0,
    FromWareHouseID: 0,
    ToWareHouseID: 0,
    VendorID: 0,
    InvoiceNumber: "",
    ActualInventory: 0,
    TransactionUnits: 0,
    // LowStockThreshold: 0,
    // HighStockThreshold: 0,
    FinalInventory: 0,
    Status: 1,
    CreatedBy: currentUser.Id,
    Location: "",
    LotNumber:"",
    LotDate:new Date()
  });

  const newFormData = { ...addFormData };

  const handlePoupClick = () => {
    newFormData.TransactionTypeID =
      newFormData.FromWareHouseID =
      newFormData.ToWareHouseID =
      newFormData.VendorID =
      0;
    newFormData.TransactionTypeOption =
      newFormData.FromWarehouseOption =
      newFormData.ToWarehouseOption =
      newFormData.VendorOption =
      null;

    newFormData.InvoiceNumber = newFormData.TransactionUnits = newFormData.LotNumber= "";
    newFormData.LotDate=new Date();
    newFormData.FinalInventory = 0;
    setAddFormData(newFormData);

    //dispatch(inventoryHistoryActions.getStockQuantity({ ProductID }));

    dispatch(productActions.GetProductDetailsByID({ ProductID }));

    setLargeModal(true);
    setSubmitted(false);
    setIsDisabled(false);
  };

  const handlechanges = () => {
    navigate("/StockManagement");
  };

  useEffect(() => {
    if (ProductID && ProductID > 0) {
      newFormData.ProductID = ProductID;
      newFormData.ProductName = ProductName;
      newFormData.Location = Location;
      setAddFormData(newFormData);

      dispatch(
        inventoryHistoryActions.getInventoryHistoryListByID({ ProductID })
      );
    }
    let TransactionTypeID = 0;
    let Status = 1;
    dispatch(
      masterActions.GetTransactionTypeDrpList({ TransactionTypeID, Status })
    );
    let VendorID = 0;
    dispatch(masterActions.GetvendorDrpList({ VendorID, Status }));
    let WareHouseID = 0;
    dispatch(masterActions.GetWarehouseList({ WareHouseID, Status }));
  }, [dispatch]);

  return (
    <>
      <PageTitle activeMenu="Transaction History" motherMenu="Inventory" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Transaction History</h4>
          <div className="float-sm-end">
            {currentUser.UserTypeID !== 6 && currentUser.UserTypeID !== 8 && (
              <Button
                className="me-2"
                variant="primary btn-rounded"
                onClick={handlePoupClick}
              >
                <span className="btn-icon-start text-primary">
                  <i className="fa fa-plus color-info" />
                </span>
                New Transaction
              </Button>
            )}
            <Button variant="btn btn-danger" onClick={handlechanges}>
              Back
            </Button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            {/* <div className="col-md-3 mb-3">
                            <label className="text-black font-w500 filtercss">Product ID </label>
                            <div className="contact-name">
                                <input type="text"
                                    className={`form-control readonly_css`}
                                    autoComplete="off"
                                    name="Product ID" required="required"
                                    value={addFormData.ProductID}
                                    disabled
                                />
                                <span className="validation-text"></span>
                            </div>
                        </div> */}
            <div className="col-md-3 mb-3">
              <label className="text-black font-w500 filtercss">
                Product Name
              </label>
              <div className="contact-name">
              <span className="badge-light light badge font-w500">
              {addFormData.ProductName}
              </span>
                {/* <input
                  type="text"
                  className={`form-control readonly_css`}
                  autoComplete="off"
                  name="Description"
                  required="required"
                  value={addFormData.ProductName}
                  disabled
                /> */}
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <label className="text-black font-w500 filtercss">
                Location{" "}
              </label>
              <div className="contact-name">
              <span className="badge-light light badge font-w500">
              {addFormData.Location}
              </span>
                {/* <input
                  type="text"
                  className={`form-control readonly_css`}
                  autoComplete="off"
                  name="Location"
                  required="required"
                  value={addFormData.Location}
                  disabled
                /> */}
                <span className="validation-text"></span>
              </div>
            </div>
          </div>
          <Table columns={columns} data={inventoryHistoryList} />
        </div>
      </div>

      <Modal className="fade bd-example-modal-lg" show={largeModal} size="lg">
        <Modal.Header>
          <Modal.Title>Inventory Management</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setLargeModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">
                Transaction Type <span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix={"custom_select_css"}
                name="TransactionTypeID"
                value={newFormData.TransactionTypeOption}
                onChange={(event) =>
                  handleDrpChange(event, "TransactionTypeID")
                }
                options={transactionTypeDrpList}
                styles={
                  submitted && newFormData.TransactionTypeID === 0 ? styles : ""
                }
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">
                Warehouse<span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix={"custom_select_css"}
                name="FromWareHouseID"
                value={newFormData.FromWarehouseOption}
                onChange={(event) => handleDrpChange(event, "FromWareHouseID")}
                options={warehouseDrpList}
                styles={
                  submitted && newFormData.FromWareHouseID === 0 ? styles : ""
                }
              />
            </div>
            {newFormData.TransactionTypeID === 2 && (
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  To Warehouse<span className="text-danger">*</span>{" "}
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="ToWareHouseID"
                  value={newFormData.ToWarehouseOption}
                  onChange={(event) => handleDrpChange(event, "ToWareHouseID")}
                  options={warehouseDrpList}
                  styles={
                    submitted && newFormData.ToWareHouseID === 0 ? styles : ""
                  }
                />
              </div>
            )}

            {newFormData.TransactionTypeID === 1 && (
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Vendor<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  value={newFormData.VendorOption}
                  name="VendorID"
                  onChange={(event) => handleDrpChange(event, "VendorID")}
                  options={vendorDrpList}
                  styles={submitted && newFormData.VendorID === 0 ? styles : ""}
                />
              </div>
            )}

            {(newFormData.TransactionTypeID === 3 ||
              newFormData.TransactionTypeID === 4) && (
                <div className="col-md-6 mb-3">
                  <label className="text-black font-w500">Vendor</label>
                  <input
                    type="text"
                    className="form-control readonly_css"
                    value="Gemar"
                    disabled
                  />
                </div>
              )}

            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">
                Invoice Number<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${submitted && !newFormData.InvoiceNumber && "border-danger"
                    }`}
                  autoComplete="off"
                  name="InvoiceNumber"
                  required="required"
                  onChange={handleChange}
                  placeholder="Invoice Number"
                  value={newFormData.InvoiceNumber}
                  maxLength={15}
                />
                <span className="validation-text"></span>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">Actual Inventory </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control readonly_css `}
                  autoComplete="off"
                  name="ActualInventory"
                  required="required"
                  placeholder="Actual Inventory"
                  value={
                    getInventoryDetails && getInventoryDetails.StockQuantity
                  }
                  disabled
                />
                <span className="validation-text"></span>
              </div>
            </div>
            {/* <div className="col-md-6 mb-3">
                            <label className="text-black font-w500">Low Stock Threshold</label>
                            <div className="contact-name">
                                <input type="text"
                                    className={`form-control readonly_css`}
                                    autoComplete="off"
                                    name="LowStockThreshold" required="required"
                                    placeholder="Low Stock Threshold"
                                    value={getInventoryDetails && getInventoryDetails.LowStockThreshold}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="text-black font-w500">High Stock Threshold</label>
                            <div className="contact-name">
                                <input type="text"
                                    className={`form-control readonly_css`}
                                    autoComplete="off"
                                    name="HighStockThreshold" required="required"
                                    placeholder="High Stock Threshold"
                                    value={getInventoryDetails && getInventoryDetails.HighStockThreshold}
                                    disabled
                                />
                            </div>
                        </div> */}
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">
                {" "}
                Transaction Units <span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${submitted &&
                    !addFormData.TransactionUnits &&
                    "border-danger"
                    }`}
                  autoComplete="off"
                  name="TransactionUnits"
                  required="required"
                  onChange={(e) => handleChange(e)}
                  placeholder="Transaction Units"
                  value={newFormData.TransactionUnits}
                  maxLength={6}
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500"> Final inventory</label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control readonly_css`}
                  autoComplete="off"
                  name="FinalInventory"
                  required="required"
                  onChange={handleChange}
                  placeholder="Final Inventory"
                  value={newFormData.FinalInventory}
                  disabled
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500"> Location</label>
              <div className="contact-name">
                <label
                >{newFormData.Location}</label>
                <span className="validation-text"></span>
              </div>
            </div>
            {newFormData.TransactionTypeID === 1 && (
              <>
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">
              Lot Number<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${submitted && !newFormData.LotNumber && "border-danger"
                    }`}
                  autoComplete="off"
                  name="LotNumber"
                  required="required"
                  onChange={handleChange}
                  placeholder="Lot Number"
                  value={newFormData.LotNumber}
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-black font-w500">
              Lot Date<span className="text-danger">*</span>
              </label>
              <div className={`date-picker-wrapper ${submitted && !newFormData.LotDate ? "border-danger" : ""}`}>
               <DatePicker
                  className={`form-control`}
                   name="LotDate"
                   initialDate={newFormData.LotDate}
                   selected={newFormData.LotDate}
                  placeholder="MM/DD/YYYY"
                  showDefaultIcon={true}
                  dateFormat="MM/DD/YYYY" // Set date format here
                  onChange={handleDateChange}
                  style={{ width: "100%", height: "48px" }}
                    />
                     
        </div>
               
             
              <span className="validation-text"></span>
            </div>
            </>
              )}

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setLargeModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            //disabled={`${newFormData.TransactionTypeID === 2 ? 'true' : 'false'}`}
            disabled={
              newFormData.TransactionTypeID === 2 || isdisabled ? true : false
            }
            //onClick={() => setLargeModal(false)}
            onClick={handleAddFormSubmit}
            className="btn btn-primary"
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      {loader}
    </>
  );

};


export default InventoryHistory;
